<template>
  <div style="position:relative">
    <Spin fix v-if="loadingGroup">加载中..</Spin>
    <Card v-if="selectProject.dataSource!=='竞价平台'" class="supplier-select" v-for="group in groupList" :key="group.id" style="margin-top:5px;">
      <span slot="title">包组{{group.groupNo}}：{{group.groupName}}</span>
      <Table :columns="bidCompanyColumns" :data="group.enrollList"></Table>
    </Card>
    <div v-if="selectProject.dataSource==='竞价平台'">
      <Table :columns="platformColumns" :data="platformSuppliers"></Table>
    </div>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import axios from 'axios'
// import qs from 'qs'

export default {
  props: {
    selectProject: {
      type: Object
    },
  },
  data() {
    return {
      groupList: [],
      bidCompanyColumns: [
        {
          title: '投标单位',
          key: 'companyName',
          render: (h, params) => {
            return h('div', params.row.abpEnroll.companyName)
          }
        },
        {
          title: '中标金额',
          width: 85,
          key: 'winAmount'
        },
        {
          title: '应收款',
          width: 85,
          key: 'receivable'
        },
        {
          title: '是否中标',
          width: 85,
          key: 'isWin',
          render: (h, params) => {
            let status = '否'
            if (params.row.status) {
              status = '是'
            }
            return h('div', status)
          }
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.selectSupplier(params.row)
                  }
                }
              }, '选择')
            ])
          }
        }
      ],
      platformColumns: [
        {
          title: '投标单位',
          key: 'companyName',
          render: (h, params) => {
            return h('div', params.row.companyName)
          }
        },
        {
          title: '操作',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.selectSupplier(params.row)
                  }
                }
              }, '选择')
            ])
          }
        }
      ],
      loadingGroup: false,
      platformSuppliers: []
    }
  },
  methods: {
    // 获取包组
    async getGroup(projectId) {
      let rep = await ajax.get(requestUrls.ClGroupDb.getPaged, {
        params: {
          filter: `projectId=="${projectId}"`,
          maxResultCount: 500,
          skipCount: 0
        }
      })
      if (rep.data.success) {
        this.groupList = this.handleGroupList(rep.data.result.items)
      }
    },
    // 获取当前项目所有包组的所有报名供应商
    // async getGroupEnroll(projectId) {
    //   // 这个获取有点慢，加个遮罩
    //   this.loadingGroup = true
    //   let rep = await ajax.get(requestUrls.YbDb.getPaged, {
    //     params: {
    //       filter: `nproId==${projectId}`,
    //       soting: 'id desc',
    //       maxResultCount: 500,
    //       skipCount: 0,
    //     }
    //   })
    //   this.loadingGroup = false
    //   if (rep.data.success) {

    //     if (this.selectProject.dataSource === '竞价平台') {
    //       this.platformSuppliers = rep.data.result.items
    //     }
    //     if (this.selectProject.dataSource === '内网立项') {
    //       this.sortEnroll(rep.data.result.items)
    //     }
    //   }
    // },
    // 直接获取报名供应商
    async getEnroll() {
      let rep = await ajax.get(requestUrls.enroll.getPaged, {
        params: {
          filter: `e.projectId=="${this.selectProject.id}"`,
          maxResultCount: 100,
          skipCount: 0
        }
      })
      this.platformSuppliers = []
      if (rep.data.success) {
        this.platformSuppliers = rep.data.result.items
      }
    },
    // 获取附属表所有报名
    async getEnrollExt() {
      this.groupList = this.groupList.filter(group => {
        // group.enrollList = []
        this.$set(group, 'enrollList', [])
        return group
      })
      let rep = await ajax.get(requestUrls.enroll.GetEnrollExt, {
        params: {
          pid: this.selectProject.id
        }
      })
      if (rep.data.success) {
        this.sortEnrollExt(rep.data.result.items)
      }
    },
    sortEnrollExt(enrollExtList = []) {
      enrollExtList.forEach(enrollExt => {
        for (let i = 0; i < this.groupList.length; i++) {
          let group = this.groupList[i]
          if (group.id === enrollExt.groupId) {
            if (!enrollExt.abpEnroll.isDeleted && enrollExt.abpEnroll.status === '3' && enrollExt.status) {
              group.enrollList.push(enrollExt)
            }
            break
          }
        }
      })
    },
    // 包组供应商分类
    // sortEnroll(enrollList = []) {
    //   this.groupList.forEach(group => {
    //     this.$set(group, 'enrollList', [])
    //     for (let i = 0; i < enrollList.length; i++) {
    //       // 中标才放进数据
    //       if (enrollList[i].groupId === group.id && enrollList[i].isWin === '中标') {
    //         group.enrollList.push(enrollList[i])
    //       }
    //     }
    //   })
    // },
    // 包组排序
    handleGroupList(groupList) {
      let orderList = []
      groupList.forEach(group => {
        let index = parseInt(group.groupNo) - 1
        orderList[index] = group
      })
      let orderResult = []
      // 去除空数据并记录第一个空的位置
      for (let i = 0; i < orderList.length; i++) {
        let item = orderList[i]
        if (item) {
          orderResult.push(item)
        }
      }
      return orderResult
    },
    selectSupplier(row) {
      if (this.selectProject.dataSource === '竞价平台') {
        this.$emit('endImport', {
          receivable: '',
          abpEnroll: {
            companyName: row.companyName,
            companyNo: row.projectFull
          },
          groupId: row.groupId
        })
      } else {
        this.$emit('endImport', row)
      }
    }
  },
  watch: {
    async selectProject(val) {
      if (val.id) {
        if (val.dataSource === '竞价平台') {
          await this.getEnroll()
        } else {
          await this.getGroup(val.id)
          await this.getEnrollExt(val.id)
        }
      }
    }
  }
}
</script>

<style lang="less">
.supplier-select {
  .ivu-card-body {
    padding: 0;
  }
}
</style>
